module.exports = __webpack_public_path__ + "img/icon-home-ev-03.dcd2a138.png";